import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { customerInsuranceList } from '@/views/insurance/releaseManage/request.js';
import { userList } from '@/views/customer/accountManage/request.js';
import { orderStoreCase } from './request';
export default {
  name: 'add-order',
  data() {
    return {
      addVisible: false,
      addForm: {
        production: '',
        user: '',
        payment: '',
        payState: '',
        number: ''
      },
      productionSelectList: [],
      userSelectList: [],
      paymentSelectList: [{
        key: 1,
        name: '微信'
      }, {
        key: 2,
        name: '支付宝'
      }, {
        key: 3,
        name: '银联'
      }, {
        key: 4,
        name: '易宝'
      }, {
        key: 5,
        name: '三方支付链接'
      }],
      payStateSelectList: [{
        key: 1,
        name: '已支付'
      }, {
        key: 2,
        name: '已退款'
      }, {
        key: 3,
        name: '部分退款'
      }, {
        key: 4,
        name: '待支付'
      }, {
        key: 5,
        name: '取消支付'
      }]
    };
  },
  computed: {
    ADD_RULES() {
      return {
        production: [{
          required: true,
          message: this.$t('请选择') + this.$t('产品'),
          trigger: 'change'
        }],
        user: [{
          required: true,
          message: this.$t('请选择') + this.$t('用户'),
          trigger: 'change'
        }],
        payment: [{
          required: true,
          message: this.$t('请选择') + this.$t('支付方式'),
          trigger: 'change'
        }],
        payState: [{
          required: true,
          message: this.$t('请选择') + this.$t('支付状态'),
          trigger: 'change'
        }],
        number: [{
          required: true,
          message: this.$t('请输入') + this.$t('订单号'),
          trigger: 'blur'
        }]
      };
    }
  },
  watch: {
    authorityType(newV) {
      this.tag = newV;
    }
  },
  methods: {
    async openModal() {
      const {
        items
      } = await customerInsuranceList({
        page: 1,
        pageSize: 100000
      });
      this.productionSelectList = items;
      this.addVisible = true;
    },
    saveAdd() {
      this.$refs.addRef.validate(async valid => {
        if (valid) {
          let params = {
            customerInsuranceId: this.addForm.production,
            userId: this.addForm.user,
            payType: this.addForm.payment,
            payStatus: this.addForm.payState,
            orderNo: this.addForm.number
          };
          const res = await orderStoreCase(params);
          this.addVisible = false;
          this.resetForm();
          this.$emit('save');
        }
      });
    },
    async productionChange() {
      this.userSelectList = [];
      this.addForm.user = '';
      if (this.addForm.production) {
        let customerId = this.productionSelectList.find(i => i.id === this.addForm.production).customerId;
        const {
          items
        } = await userList({
          customerId,
          page: 1,
          pageSize: 100000
        });
        this.userSelectList = items;
      }
    },
    resetForm() {
      this.$refs.addRef.resetFields();
    },
    closeAddVisible() {
      this.addVisible = false;
      this.resetForm();
    }
  }
};